/**
 * 创作者中心- 模型训练
 * @returns
 */
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { Flex, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Text, HStack, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Input, Select, SliderTrack, SliderThumb, SliderFilledTrack, Slider, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, SimpleGrid, useDisclosure, CircularProgress, Icon, useToast, Image as ChakraImage, Textarea, Tooltip } from "@chakra-ui/react";
import { RiAddBoxLine, RiBox3Line, RiDeleteBin4Line, RiExpandDiagonalLine, RiInformationLine, RiPriceTag3Line, RiUpload2Line } from "@remixicon/react";
import { useCallback, useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./modelSlick.css";
import { ModelTrainingParams, TrainingPicture } from "@/types/creatorcenter";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import down from "@/assets/down.svg";
import { selectTrainingParams, updateTrainingParams, updateTrainingPictures, selectTrainingPictures, selectCurrentTrainId, addTrainPicture, selectMymodel, updateModelTrainType } from "@/reducer/mymodelSlice";
import TrainingPictureItem from "./trainingPictureItem";
import IsMarkingModal from "./isMarkingModal";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Model } from "@/types/design";
import TestingModal from "./TestingModal";
import { useDropzone } from "react-dropzone";
import TrainingBaseModesModal from "./trainingModes/trainingBaseModeModal";
import TraingHighSettingModal from "./traningHighSetting";
import TraingResultModal from "./trainingResultModal";
import smartcrop from "smartcrop";

import { useDeleteTaggerMutation, useTaggerMutation, useTaggerSearchMutation, useTrainMutation } from "@/services/api/endpoints/model";
import { dataURLtoFile } from "@/utils/utils";
import { current } from "@reduxjs/toolkit";
import { FaLess } from "react-icons/fa";
import modelImg1 from "@/assets/images/model_img4.png";
import modelImg2 from "@/assets/images/model_img1.png";
import modelImg3 from "@/assets/images/model_img2.png";
import modelImg4 from "@/assets/images/model_img3.png";
import modelImg5 from "@/assets/images/model_img5.png";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  handleOpenResult: () => void;
};

type ModelStyle = {
  name: string;
  background: string;
};

var clipFiles: File[] = []; //临时存放裁剪后的图片
var timer: any;
var uploadFiles: TrainingPicture[] = [];

const NewTrainingModal = (props: Props) => {
  const { isOpen, onClose, handleOpenResult } = props;
  const toast = useToast();
  const user = useSelector(selectUser);
  const MarkingControl = useDisclosure();
  const largeModeControl = useDisclosure();
  const TestingControl = useDisclosure();
  // const ResultControl = useDisclosure();
  const SettingControl = useDisclosure();

  const dispatch = useAppDispatch();
  const trainingParams = useAppSelector(selectTrainingParams);
  const trainingPictures = useAppSelector(selectTrainingPictures);
  const currentTrainId = useAppSelector(selectCurrentTrainId);

  // const [trainingPictures, setTrainingPictures] = useState<TrainingPicture[]>([]);
  const [isMarking, setIsMarking] = useState(false);
  const [isMarkingFinish, setIsMarkingFinish] = useState(true);
  const maxSize = 10 * 1024 * 1024; // 10MB
  const [files, setFiles] = useState<File[]>([]);

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [clipType, setClipType] = useState<string>("中央裁剪");
  const [clipSize, setClipSize] = useState<string>("512*512");
  const [threshold, setThreshold] = useState<number>(0.35);
  const [additionalTags, setAdditionalTags] = useState<string>("art1001");
  const [repeatVal, setRepeatVal] = useState<number>(trainingParams.repeat || 10);
  const [maxEpochsVal, setMaxEpochsVal] = useState<number>(trainingParams.max_train_epochs || 7);

  console.log("uoloadFiles====", uploadFiles);

  const models: ModelStyle[] = [
    {
      name: "FLUX",
      background: `${modelImg1}`,
    },
    {
      name: "XL",
      background: `${modelImg2}`,
    },
    {
      name: "1.5L",
      background: `${modelImg5}`,
    },
    // {
    //   name: "3.5L",
    //   background: `${modelImg3}`,
    // },
    {
      name: "画风",
      background: `${modelImg4}`,
    },
  ];

  const [tagger] = useTaggerMutation();
  const [taggerSearch] = useTaggerSearchMutation();
  const [deleteTagger] = useDeleteTaggerMutation();
  const [train] = useTrainMutation();

  const handleStartTraining = async () => {
    const nullValue = trainingPictures.filter((item) => item.file_content == "");
    if (trainingPictures.length == 0 || nullValue.length > 0) {
      toast({
        title: "请上传图片并打标",
        position: "top",
        status: "error",
        duration: 1000,
      });
      return;
    }
    uploadFiles = [];
    setFiles([]);
    let res = await train({
      userId: user.id,
      trainId: currentTrainId,
      trainingParams: trainingParams,
      trigger_word: additionalTags,
    });
    // ResultControl.onOpen();
    if (res) {
      onClose();
      handleOpenResult();
    }
  };

  const handleHighSetting = () => {
    SettingControl.onOpen();
  };

  const handleAutoMarking = () => {
    MarkingControl.onOpen();
  };

  const handleOpenLargeModesModal = () => {
    largeModeControl.onOpen();
  };

  const handleChangeBaseMode = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const modename = e.target.value;
    const newParams = {
      ...trainingParams,
      pretrained_model_name_or_path: "./sd-models/" + modename + ".safetensors",
    };
    dispatch(updateTrainingParams(newParams));
  };

  const changeBaseMode = (mode: Model) => {
    const newParams = {
      ...trainingParams,
      pretrained_model_name_or_path: "./sd-models/" + mode.realname + ".safetensors",
    };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeModelName = (e: React.ChangeEvent<HTMLInputElement>) => {
    // 使用正则表达式匹配非英文字符，并将其替换为空字符
    const transformedValue = e.target.value.replace(/[^a-zA-Z]/g, "");
    const newParams = { ...trainingParams, output_name: transformedValue };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeTrainingSteps = (value: number) => {
    const newParams = { ...trainingParams, training_steps: value };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeSingleTimes = (value: number) => {
    setRepeatVal(value);
    const newParams = { ...trainingParams, repeat: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeSingleTimesInput = (value: number) => {
    if (isNaN(value)) {
      setRepeatVal(1);
    } else {
      setRepeatVal(value);
    }
  };
  const handleChangeSingleTimesBlur = () => {
    const newParams = { ...trainingParams, repeat: repeatVal };
    dispatch(updateTrainingParams(newParams));
  };

  const handleChangeLooprounds = (value: number) => {
    setMaxEpochsVal(value);
    const newParams = { ...trainingParams, max_train_epochs: value };
    dispatch(updateTrainingParams(newParams));
  };
  const handleChangeLooproundsInput = (value: number) => {
    if (isNaN(value)) {
      setMaxEpochsVal(1);
    } else {
      setMaxEpochsVal(value);
    }
  };
  const handleChangeLooproundsBlur = () => {
    const newParams = { ...trainingParams, max_train_epochs: maxEpochsVal };
    dispatch(updateTrainingParams(newParams));
  };

  const handleClipSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setClipSize(value);
    const newParams = { ...trainingParams, resolution: value.replace("*",",") };
    dispatch(updateTrainingParams(newParams));
  };

  const resizeImage = async (file_path: string, width: number, height: number) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = file_path;
    const canvas = document.createElement("canvas");
    return new Promise((resolve, reject) => {
      img.onload = async () => {
        if (!canvas) return;
        console.log("21");
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        // 设置画布大小
        canvas.width = width;
        canvas.height = height;
        // 计算新的绘制宽度和高度，保持图片比例不变
        let drawWidth = width;
        let drawHeight = height;
        // 如果图片宽高比大于画布的宽高比，以画布高度为基准进行缩放
        if (img.naturalWidth / img.naturalHeight > width / height) {
          drawHeight = height;
          drawWidth = (height / img.naturalHeight) * img.naturalWidth;
        } else {
          // 如果图片宽高比小于或等于画布的宽高比，以画布宽度为基准进行缩放
          drawWidth = width;
          drawHeight = (width / img.naturalWidth) * img.naturalHeight;
        }
        // 获取画布中心点
        var canvasCenterX = canvas.width / 2;
        var canvasCenterY = canvas.height / 2;
        // 计算图片中心点以对齐画布中心
        var imageCenterX = drawWidth / 2;
        var imageCenterY = drawHeight / 2;
        ctx.drawImage(img, canvasCenterX - imageCenterX, canvasCenterY - imageCenterY, drawWidth, drawHeight);
        const resizedSrc = canvas.toDataURL("image/jpg");
        const imgfile = dataURLtoFile(resizedSrc, "resizedImage.jpg");
        // clipFiles.push(imgfile);
        // console.log(clipFiles, "clipFiles>>");
        await handleUploadImages(imgfile);
        URL.revokeObjectURL(img.src); // 释放对象URL
        resolve(0);
      };

      img.onerror = (error) => {
        console.error("Image loading error:", error);
        reject(error); // 当图片加载失败时，返回错误
      };
    });
  };

  const focusClipImage = async (file_path: string, width: number, height: number) => {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    image.src = file_path;
    const canvas = document.createElement("canvas");
    return new Promise((resolve, reject) => {
      image.onload = async () => {
        // const crop = smartcrop.crop(image, { width, height });
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        canvas.width = width;
        canvas.height = height;
        const result = await smartcrop.crop(image, { width, height });
        ctx.drawImage(image, result.topCrop.x, result.topCrop.y, result.topCrop.width, result.topCrop.height, 0, 0, width, height);
        const resizedSrc = canvas.toDataURL("image/jpg");
        const imgfile = dataURLtoFile(resizedSrc, "resizedImage.jpg");
        // clipFiles.push(imgfile);
        // console.log(clipFiles, "clipFiles>>");
        await handleUploadImages(imgfile);
        URL.revokeObjectURL(image.src); // 释放对象URL
      };
      image.onerror = (error) => {
        console.error("Image loading error:", error);
        reject(error); // 当图片加载失败时，返回错误
      };
    });
  };

  const getImageNameWithoutExtension = (imageUrl: string) => {
    // 使用lastIndexOf找到最后一个斜杠的位置
    const lastSlashIndex = imageUrl.lastIndexOf("/") + 1;
    // 使用substring获取图片名称部分
    const imageNameWithExtension = imageUrl.substring(lastSlashIndex);
    // 使用lastIndexOf找到最后一个点的位置
    const lastDotIndex = imageNameWithExtension.lastIndexOf(".");
    // 如果找不到点，则返回整个字符串；否则使用substring截取不含后缀的图片名称
    return lastDotIndex === -1 ? imageNameWithExtension : imageNameWithExtension.substring(0, lastDotIndex);
  };

  //  图片上传
  const handleUploadImages = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch("https://images.aldgptai.com/upload", {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      throw new Error(`Server responded with status code ${response.status}`);
    }
    const data = await response.json();
    if (data.image_url) {
      const imgsize = clipSize.split("*");
      const pic: TrainingPicture = {
        file_id: data.file_name.split(".")[0],
        file_path: data.image_url,
        file_content: "",
        width: Number(imgsize[0]),
        height: Number(imgsize[1]),
      };
      uploadFiles.push(pic);
    }
  };
  //  图片上传
  const handleUpload = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch("https://images.aldgptai.com/upload", {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      throw new Error(`Server responded with status code ${response.status}`);
    }
    const data = await response.json();
    if (data.image_url) {
      const imgsize = clipSize.split("*");
      const pic: TrainingPicture = {
        file_id: data.file_name.split(".")[0],
        file_path: data.image_url,
        file_content: "",
        width: Number(imgsize[0]),
        height: Number(imgsize[1]),
      };
      dispatch(addTrainPicture(pic));
    }
  };
  const handleDrop = useCallback(
    async (acceptedFiles: File[]) => {
      // 处理接收到的文件，例如上传到服务器
      if (files.length + acceptedFiles.length > 50) {
        toast({
          title: "图片数量超过50张，上传失败。",
          position: "top",
          status: "error",
        });
      } else if (acceptedFiles.length > 0) {
        console.log(acceptedFiles, "azazaz");
        const newFile = files.length > 0 ? [...acceptedFiles, ...files] : [...acceptedFiles];
        console.log(newFile, "123");
        setFiles(newFile);
        // toast({ title: "图片已上传。", position: "top", status: "success" });
        //let currentTrainingImages = [...trainingPictures];
        //acceptedFiles.forEach(item => currentTrainingImages.unshift({ file_id: "", file_path: URL.createObjectURL(item), file_content: ""}))
        //console.log(currentTrainingImages, "1111");
        acceptedFiles.forEach((item) => handleUpload(item));

        //let currentTrainingImages = [...trainingPictures];
        //dispatch(updateTrainingPictures(currentTrainingImages));
        // setTrainingPictures(currentTrainingImages)
      }
    },
    [toast, files]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".jpg", ".png"],
    },
    maxFiles: 50,
    maxSize: maxSize,
    onDrop: handleDrop,
    noClick: true,
    multiple: true,
    noDrag: true,
    onDropRejected: () => {
      toast({
        title: "上传的文件类型(仅支持png、jpeg)或数量不符合要求！",
        position: "top",
        status: "error",
      });
    },
  });

  const handleReloadTrainPictures = () => {
    dispatch(updateTrainingPictures([]));
    setFiles([]);
    uploadFiles = [];
  };
  const handleDeletePicture = (index: number) => {
    let newfiles = [...files];
    newfiles.splice(index, 1);
    setFiles(newfiles);
    let currentTrainingImages: TrainingPicture[] = [...trainingPictures];
    currentTrainingImages.splice(index, 1);
    dispatch(updateTrainingPictures(currentTrainingImages));

    const imgs = trainingPictures.filter((item) => item.file_content != "");
    if (imgs) {
      const fileIds = imgs.map((item) => item.file_id);
      deleteTagger({ userId: user.id, fileIds: fileIds });
    }
  };

  const handleOpen = () => {
    if (user && user.id) {
      open();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  const handleClipOrMark = async () => {
    setIsMarking(true);
    uploadFiles = [];
    const imgsize = clipSize.split("*");
    if (clipType === "中央裁剪") {
      for (const file of trainingPictures) {
        await resizeImage(file.file_path, Number(imgsize[0]), Number(imgsize[1]));
      }
    }
    if (clipType === "聚焦裁剪") {
      for (const file of trainingPictures) {
        await focusClipImage(file.file_path, Number(imgsize[0]), Number(imgsize[1]));
      }
    }
    // if (clipType === "无需裁剪") {
    // }
    dispatch(updateTrainingPictures(uploadFiles));
    console.log(files.length, trainingPictures.length);
    if (trainingPictures.length === files.length) {
      const result = await tagger({
        userId: user.id,
        threshold: threshold,
        additional_tags: additionalTags,
        images: trainingPictures.map((item) => item.file_path),
        train_id: currentTrainId,
        width: Number(imgsize[0]),
        height: Number(imgsize[1]),
      });
      if (result.data) {
        timer = setInterval(async () => {
          const taggerSearchParam = trainingPictures.map((item) => item.file_id);
          console.log(taggerSearchParam, "taggerSearchParam>>>>>>");
          const search = (await taggerSearch(taggerSearchParam)).data!;
          console.log(search, "result-timer>>>>>>");
          const res = search.filter((item) => item.file_content == "");
          if (res.length == 0) {
            clearInterval(timer);
            setIsMarking(false);
            dispatch(updateTrainingPictures(search));
          }
        }, 5000);
      }
    }
  };

  useEffect(() => {
    dispatch(updateTrainingPictures([]));
    return () => {
      clipFiles = []; //临时存放裁剪后的图片
      uploadFiles = [];
    };
  }, [isOpen]);

  const handleChangeModelTrainType = (item: ModelStyle) => {
    dispatch(updateModelTrainType(item.name));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff" h="100vh">
        <ModalHeader
        // borderBottom={"1px solid #DCE0EB"}
        >
          <Text color="#27314D" fontSize={"18px"}>
            模型训练
          </Text>
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody>
          <Flex h="100%" flexDirection={"column"}>
            <Flex mb="10px" justifyContent={"space-between"} alignItems="center">
              <Flex gap="10px">
                {models.length > 0 &&
                  models.map((item) => (
                    <Box w="120px" h="68px" key={item.name} cursor="pointer" position={"relative"} borderRadius="10px" overflow={"hidden"} border={trainingParams.train_type === item.name ? "2px solid #496AE1" : "none"} onClick={() => handleChangeModelTrainType(item)}>
                      <ChakraImage w="100%" h="100%" objectFit={"cover"} src={item.background} />
                      <Box color={"#fff"} fontSize="14px" bg={trainingParams.train_type === item.name ? "#496AE1" : "rgba(51, 51, 51, 0.05)"} backdropFilter={trainingParams.train_type === item.name ? "blur(0px)" : "blur(15px)"} position={"absolute"} left="0" bottom="0" w="100%" h="20px" lineHeight={"20px"} textAlign={"center"}>
                        {item.name}
                      </Box>
                    </Box>
                  ))}
              </Flex>
              <Flex alignItems={"center"}>
                <Flex h="40px" bg="rgba(238, 241, 247, 0.5)" pl="10px" pr="20px" flexDir={"column"} justifyContent="center">
                  <Text color="#27314D" fontSize="12px" fontWeight={"bold"}>
                    上传图片后计算
                  </Text>
                  <HStack spacing={"3px"}>
                    <Text color="#8E94A9" fontSize="10px">
                      预计消耗算力
                    </Text>

                    <Tooltip hasArrow placement="top" fontSize={"12px"} label="算力消耗与图片数量、单张训练次数、训练轮数有关；基于基础算法XL的训练任务算力消耗为基础算法1.5的6倍">
                      <Box>
                        <RiInformationLine color="#8E94A9" size="12px" />
                      </Box>
                    </Tooltip>
                  </HStack>
                </Flex>
                <Button
                  borderRadius={0}
                  width={"110px"}
                  height={"40px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="12px"
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  leftIcon={<RiBox3Line size={"16px"} />}
                  p="2px"
                  position={"relative"}
                  onClick={handleStartTraining}
                  isDisabled={!isMarkingFinish}
                >
                  立即训练
                </Button>
              </Flex>
            </Flex>

            <Box flex={1} h="0">
              <Flex h={"100%"} gap="20px">
                {/* 左侧 */}
                <Flex h="100%" flex={1} p="12px" flexDir="column" border="1px solid #DCE0EB" position={"relative"}>
                  <Flex mb="14px" justifyContent={"space-between"}>
                    <HStack>
                      <Box color={"#27314D"} fontWeight="bold" fontSize={"16px"}>
                        图片打标/裁剪
                      </Box>
                      <Text color={"#27314D"} fontSize={"13px"}>
                        共
                      </Text>
                      <Text color={"#496AE1"}>0</Text>
                      <Text color={"#27314D"} fontSize={"13px"}>
                        张
                      </Text>
                    </HStack>
                    <HStack>
                      {/* <Button
                    borderRadius={0}
                    height={"40px"}
                    color="#27314D"
                    bg="rgba(238, 241, 247, 0.5)"
                    fontWeight={"normal"}
                    fontSize="14px"
                    _hover={{
                      bg: "rgba(238, 241, 247, 0.5)",
                    }}
                    leftIcon={<RiPriceTag3Line size={"16px"} />}
                    position={"relative"}
                    onClick={handleAutoMarking}
                  >
                    自动打标
                  </Button> */}
                      <Button
                        borderRadius={0}
                        height={"40px"}
                        color="#27314D"
                        bg="rgba(238, 241, 247, 0.5)"
                        fontWeight={"normal"}
                        fontSize="14px"
                        _hover={{
                          bg: "rgba(238, 241, 247, 0.5)",
                        }}
                        leftIcon={<RiUpload2Line size={"16px"} />}
                        position={"relative"}
                        onClick={handleReloadTrainPictures}
                      >
                        重新上传
                      </Button>
                      <Button
                        borderRadius={0}
                        height={"40px"}
                        color="#27314D"
                        bg="rgba(238, 241, 247, 0.5)"
                        fontWeight={"normal"}
                        fontSize="14px"
                        _hover={{
                          bg: "rgba(238, 241, 247, 0.5)",
                        }}
                        leftIcon={<RiAddBoxLine size={"16px"} />}
                        position={"relative"}
                        onClick={handleOpen}
                        isDisabled={isMarking}
                      >
                        添加图片
                      </Button>
                    </HStack>
                  </Flex>

                  <Box flex={1} h="0" overflowY={"auto"}>
                    {trainingPictures.length === 0 && (
                      <Flex h="100%" flexDir={"column"} gap="10px" justifyContent="center" alignItems={"center"} {...getRootProps()}>
                        <input {...getInputProps()} />
                        {/* <canvas ref={canvasRef} style={{ display: "none" }} /> */}
                        <RiUpload2Line color="#CBD1DF" size="50px" />
                        <Button variant="link" color={"#496AE1"} fontSize={"14px"} onClick={handleOpen}>
                          点击上传图片
                        </Button>
                        <Text color={"#616161"} fontSize={"12px"}>
                          或拖入训练素材，推荐上传5-50张图，最大不超过 10M，支持jpg/png/jpeg
                        </Text>
                        {/* <ChakraImage src={files[0]} /> */}
                      </Flex>
                    )}

                    <SimpleGrid columns={4} spacing={"5px"}>
                      {trainingPictures.length > 0 &&
                        trainingPictures.map((item, index) => (
                          <Box key={item.file_path}>
                            <TrainingPictureItem picture={item} onDelete={() => handleDeletePicture(index)} />
                          </Box>
                        ))}
                    </SimpleGrid>
                  </Box>
                  <Box>
                    <Flex gap="10px" alignItems={"end"}>
                      <Box>
                        <Box fontSize="13px" mb="5px" color={"#8E94A9"}>
                          裁剪方式
                        </Box>
                        <Select
                          isDisabled={trainingPictures.length === 0}
                          icon={<ReactSVG src={down} />}
                          variant="Unstyled"
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                          value={clipType}
                          onChange={(e) => {
                            setClipType(e.target.value);
                          }}
                        >
                          <option value="中央裁剪">中央裁剪</option>
                          <option value="聚焦裁剪">聚焦裁剪</option>
                          <option value="无需裁剪">无需裁剪</option>
                        </Select>
                      </Box>
                      <Box>
                        <Box fontSize="13px" mb="5px" color={"#8E94A9"}>
                          裁剪尺寸
                        </Box>
                        <Select
                          isDisabled={trainingPictures.length === 0}
                          icon={<ReactSVG src={down} />}
                          variant="Unstyled"
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                          value={clipSize}
                          onChange={handleClipSize}
                        >
                          <option value="512*512">512*512</option>
                          <option value="768*768">768*768</option>
                          <option value="768*512">768*512</option>
                          {trainingParams.train_type === "FLUX" && <option value="1024*1024">1024*1024</option>}
                        </Select>
                      </Box>
                      {/* <Box>
                    <Box fontSize="13px" mb="5px" color={"#8E94A9"}>
                      打标算法
                    </Box>
                    <Select
                      // isDisabled={trainingPictures.length===0}
                      icon={<ReactSVG src={down} />}
                      variant="Unstyled"
                      bgColor="#EEF1F7"
                      h="40px"
                      border={"none"}
                      borderRadius={0}
                      fontSize="14px"
                      color={"#27314D"}
                    >
                      <option value="BLIP">BLIP</option>
                      <option value="Deepbooru">Deepbooru</option>
                      <option value="仅触发词">仅触发词</option>
                      <option value="无需标注">无需标注</option>
                      <option value="Liava">Liava</option>
                    </Select>
                  </Box> */}
                      <Box>
                        <Box fontSize="13px" mb="5px" color={"#8E94A9"}>
                          打标阈值
                        </Box>
                        <NumberInput isDisabled={trainingPictures.length === 0} h="40px" w="100px" step={0.05} max={1} min={0} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={threshold} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => setThreshold(valueAsNumber)}>
                          <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                          <NumberInputStepper w="14px">
                            <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                            <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                          </NumberInputStepper>
                        </NumberInput>
                      </Box>
                      <Box flex={1}>
                        <Box fontSize="13px" mb="5px" color={"#8E94A9"}>
                          模型触发词
                        </Box>
                        <Input
                          isDisabled={trainingPictures.length === 0}
                          placeholder="输入触发词"
                          borderRadius={0}
                          bgColor="#EEF1F7"
                          h="40px"
                          border={"none"}
                          fontSize="14px"
                          color={"#27314D"}
                          value={additionalTags}
                          onChange={(e) => {
                            setAdditionalTags(e.target.value);
                          }}
                        />
                      </Box>
                      <Button
                        isDisabled={trainingPictures.length === 0}
                        borderRadius={0}
                        width={"110px"}
                        height={"40px"}
                        color="#FFFFFF"
                        bgColor="#496AE1"
                        fontWeight={"normal"}
                        fontSize="12px"
                        _hover={{
                          bgColor: "#3F5BC1",
                          color: "#E6E6E6",
                        }}
                        onClick={handleClipOrMark}
                      >
                        裁剪/打标
                      </Button>
                    </Flex>
                  </Box>
                  {isMarking && (
                    <Flex justifyContent={"center"} alignItems="center" bg="rgba(0, 0, 0, 0.7)" position={"absolute"} top="0px" left={"0px"} w="100%" h="100%">
                      <Flex flexDir={"column"} alignItems="center">
                        <Box>
                          <CircularProgress isIndeterminate size="80px" thickness="8px"></CircularProgress>
                          {/* <CircularProgress value={70} size="80px" thickness="8px">
                        <CircularProgressLabel color={"#FFFFFF"}>
                          70%
                        </CircularProgressLabel>
                      </CircularProgress> */}
                        </Box>
                        <Box mt={"25px"} color={"#FFFFFF"} fontSize="16px" fontWeight={350}>
                          预处理中，请稍后
                        </Box>
                      </Flex>
                    </Flex>
                  )}
                </Flex>
                {/* 右侧 */}
                <Box w="352px" h="100%" border="1px solid #DCE0EB" p="12px" boxSizing="border-box" overflow={"auto"}>
                  <Box mb="14px" color={"#27314D"} fontWeight="bold" fontSize={"16px"}>
                    参数设置
                  </Box>

                  <Accordion allowToggle defaultIndex={[0]} borderColor={"#E2E8F0"} borderWidth="0 1px 0 1px" mb="20px" background="rgba(238, 241, 247, 0.5)">
                    <AccordionItem>
                      <h2>
                        <AccordionButton>
                          <Box as="span" flex="1" textAlign="left" color={"#27314D"}>
                            模型信息
                          </Box>
                          <AccordionIcon />
                        </AccordionButton>
                      </h2>
                      <AccordionPanel borderTop="1px solid #DCE0EB">
                        <Box>
                          <Flex alignItems={"center"} mb={"12px"}>
                            <Box fontSize="14px" color={"#8E94A9"} w="70px" mr="5px">
                              模型名称
                            </Box>
                            <Input flex={1} placeholder="请输入你的模型名称" borderRadius={0} bgColor="#EEF1F7" h="40px" border={"none"} fontSize="14px" color={"#27314D"} value={trainingParams.output_name} onChange={handleChangeModelName} />
                          </Flex>

                          <Flex
                            // justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box w="70px" mr="5px" fontSize="14px" color={"#8E94A9"}>
                              类型
                            </Box>
                            <Select
                              icon={<ReactSVG src={down} />}
                              variant="Unstyled"
                              flex={1}
                              bgColor="#EEF1F7"
                              h="40px"
                              border={"none"}
                              borderRadius={0}
                              fontSize="14px"
                              color={"#27314D"}
                              value={trainingParams.generatetype}
                              onChange={(e) => {
                                dispatch(
                                  updateTrainingParams({
                                    ...trainingParams,
                                    generatetype: e.target.value,
                                  })
                                );
                              }}
                            >
                              <option value="architecture">建筑设计</option>
                              {/* <option value="城市规划">城市规划</option> */}
                              <option value="decoration">室内设计</option>
                              {/* <option value="景观设计">景观设计</option> */}
                              {/* <option value="其他">其他</option> */}
                            </Select>
                          </Flex>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    // allowToggle
                    defaultIndex={[0]}
                    borderColor={"#E2E8F0"}
                    borderWidth="0 1px 0 1px"
                    background="rgba(238, 241, 247, 0.5)"
                    mb="20px"
                  >
                    <AccordionItem>
                      <Flex pr="15px" alignItems={"center"}>
                        <Box flex={1}>
                          <AccordionButton bg="none" _hover={{ bg: "none" }}>
                            <Box as="span" textAlign="left" color={"#27314D"}>
                              基础设置
                            </Box>
                            {/* <AccordionIcon /> */}
                          </AccordionButton>
                        </Box>

                        <Button
                          h="30px"
                          p="0"
                          bg={"none"}
                          _hover={{ bg: "none", color: "#27314D" }}
                          rightIcon={<RiExpandDiagonalLine color="#8E94A9" size={"16px"} />}
                          // variant="unstyled"
                          lineHeight={"30px"}
                          alignItems={"center"}
                          fontSize="14px"
                          fontWeight={"normal"}
                          color="#8E94A9"
                          onClick={handleHighSetting}
                        >
                          高级设置
                        </Button>
                      </Flex>
                      <AccordionPanel borderTop="1px solid #DCE0EB">
                        <Box>
                          <Flex alignItems="center" mb={"12px"}>
                            <Box w="70px" mr="5px" fontSize="14px" color={"#8E94A9"}>
                              基础模型
                            </Box>
                            {trainingParams.train_type === "FLUX" && (
                              <Select icon={<ReactSVG src={down} />} variant="Unstyled" flex={1} bgColor="#EEF1F7" h="40px" border={"none"} borderRadius={0} fontSize="14px" color={"#27314D"} value={getImageNameWithoutExtension(trainingParams.pretrained_model_name_or_path)} onChange={handleChangeBaseMode}>
                                <option value="flux1-dev-fp8">F.1_dev-fp8</option>
                              </Select>
                            )}
                            {trainingParams.train_type === "XL" && (
                              <Select icon={<ReactSVG src={down} />} variant="Unstyled" flex={1} bgColor="#EEF1F7" h="40px" border={"none"} borderRadius={0} fontSize="14px" color={"#27314D"} value={getImageNameWithoutExtension(trainingParams.pretrained_model_name_or_path)} onChange={handleChangeBaseMode}>
                                <option value="sd_xl_base_1.0">基础算法_XL</option>
                              </Select>
                            )}
                            {trainingParams.train_type === "1.5L" && (
                              <Select icon={<ReactSVG src={down} />} variant="Unstyled" flex={1} bgColor="#EEF1F7" h="40px" border={"none"} borderRadius={0} fontSize="14px" color={"#27314D"} value={getImageNameWithoutExtension(trainingParams.pretrained_model_name_or_path)} onChange={handleChangeBaseMode}>
                                <option value="model">基础算法V1.5L</option>
                              </Select>
                            )}
                            {trainingParams.train_type === "3.5L" && (
                              <Select icon={<ReactSVG src={down} />} variant="Unstyled" flex={1} bgColor="#EEF1F7" h="40px" border={"none"} borderRadius={0} fontSize="14px" color={"#27314D"} value={getImageNameWithoutExtension(trainingParams.pretrained_model_name_or_path)} onChange={handleChangeBaseMode}>
                                <option value="sd3.5_large">基础算法V3.5L</option>
                              </Select>
                            )}
                            {trainingParams.train_type === "画风" && (
                              <Select icon={<ReactSVG src={down} />} variant="Unstyled" flex={1} bgColor="#EEF1F7" h="40px" border={"none"} borderRadius={0} fontSize="14px" color={"#27314D"} value={getImageNameWithoutExtension(trainingParams.pretrained_model_name_or_path)} onChange={handleChangeBaseMode}>
                                <option value="anything-v5-PrtRE">万象熔炉|Anything-V5</option>
                              </Select>
                            )}

                            {/* <Flex
                          flex={1}
                          h="40px"
                          justifyContent={"space-between"}
                          alignItems="center"
                          cursor="pointer"
                          p="0 10px"
                          bgColor="#EEF1F7"
                          border={"none"}
                          borderRadius={0}
                          fontSize="14px"
                          color={"#27314D"}
                          onClick={handleOpenLargeModesModal}
                        >
                          {trainingParams.pretrained_model_name_or_path
                            ? getImageNameWithoutExtension(
                                trainingParams.pretrained_model_name_or_path
                              )
                            : "请选择"}
                          <Icon
                            color={"#27314D"}
                            boxSize={"16px"}
                            as={ChevronRightIcon}
                          />
                        </Flex> */}
                          </Flex>
                          <Flex mb={"12px"} alignItems="center" justifyContent={"space-between"}>
                            <Flex flex={1} mr="20px" fontSize="14px" color={"#8E94A9"}>
                              <Box mr="15px">单张次数</Box>
                              <Slider flex={1} value={trainingParams.repeat} step={1} min={1} max={50} onChange={handleChangeSingleTimes}>
                                <SliderTrack bg="#CBD1DF">
                                  <SliderFilledTrack bg="#496AE1" />
                                </SliderTrack>
                                <SliderThumb bg="#496AE1" boxSize={"12px"} />
                              </Slider>
                            </Flex>
                            <NumberInput h="40px" w="100px" step={1} max={50} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={repeatVal} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeSingleTimesInput(valueAsNumber)} onBlur={handleChangeSingleTimesBlur}>
                              <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                              <NumberInputStepper w="14px">
                                <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                                <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                              </NumberInputStepper>
                            </NumberInput>
                          </Flex>
                          <Flex mb={"12px"} alignItems="center" justifyContent={"space-between"}>
                            <Flex flex={1} mr="20px" fontSize="14px" color={"#8E94A9"}>
                              <Box mr="15px">循环轮次</Box>
                              <Slider flex={1} value={trainingParams.max_train_epochs} step={1} min={1} max={20} onChange={handleChangeLooprounds}>
                                <SliderTrack bg="#CBD1DF">
                                  <SliderFilledTrack bg="#496AE1" />
                                </SliderTrack>
                                <SliderThumb bg="#496AE1" boxSize={"12px"} />
                              </Slider>
                            </Flex>
                            <NumberInput h="40px" w="100px" step={1} max={20} min={1} size="xs" borderRadius={0} bgColor="#EEF1F7" border={"none"} fontSize="14px" color={"#27314D"} value={maxEpochsVal} textAlign="center" p={0} onChange={(valueAsString: string, valueAsNumber: number) => handleChangeLooproundsInput(valueAsNumber)} onBlur={handleChangeLooproundsBlur}>
                              <NumberInputField border={"none"} pr="14px" h="100%" borderRadius={0} />
                              <NumberInputStepper w="14px">
                                <NumberIncrementStepper border={"none"} fontSize={"10px"} />
                                <NumberDecrementStepper border={"none"} fontSize={"10px"} />
                              </NumberInputStepper>
                            </NumberInput>
                          </Flex>
                          <Box minH={"40px"} bg="#EEF1F7" p="10px" mb="12px" lineHeight={"25px"} fontSize={"12px"} color="#8E94A9">
                            {trainingPictures.length > 0 && (
                              <Text>
                                总步数：
                                {(trainingPictures.length / trainingParams.train_batch_size) * trainingParams.max_train_epochs * trainingParams.repeat}
                                ，预计训练时间：00:00:21 0-6点错峰训练更快哦
                              </Text>
                            )}
                            {trainingPictures.length === 0 && <Text>总步数：上传图片后计算</Text>}
                          </Box>
                          <Box fontSize="14px" color={"#8E94A9"}>
                            <Box mb="5px">
                              <Text whiteSpace={"normal"} display="inline" mr="10px">
                                模型效果预览提示词
                              </Text>
                              <Text fontSize={"10px"} whiteSpace={"normal"} display="inline">
                                训练中会根据提示词生成实时样图
                              </Text>
                            </Box>

                            <Textarea
                              flex={1}
                              placeholder="请输入提示词"
                              borderRadius={0}
                              bgColor="#EEF1F7"
                              lineHeight={"25px"}
                              border={"none"}
                              fontSize="14px"
                              color={"#27314D"}
                              rows={7}
                              value={trainingParams.prompt}
                              onChange={(e) => {
                                dispatch(
                                  updateTrainingParams({
                                    ...trainingParams,
                                    prompt: e.target.value,
                                  })
                                );
                              }}
                            />
                          </Box>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>
                </Box>
              </Flex>
            </Box>
          </Flex>

          <TraingHighSettingModal isOpen={SettingControl.isOpen} onClose={SettingControl.onClose} />

          <IsMarkingModal isOpen={MarkingControl.isOpen} onClose={MarkingControl.onClose} />

          <TrainingBaseModesModal isOpen={largeModeControl.isOpen} onClose={largeModeControl.onClose} changeBaseMode={changeBaseMode} />
          {/* <TraingResultModal
            isOpen={ResultControl.isOpen}
            onClose={ResultControl.onClose}
          /> */}
          <TestingModal isOpen={TestingControl.isOpen} onClose={TestingControl.onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NewTrainingModal;
